export const DOMAIN_CLONE_PROPERTIES = {
  clone_ads: {
    group: 'label.COPY',
    id: 'clone_ads',
    label: 'label.ADS',
    value: 'clone_ads'
  },
  clone_departments: {
    group: 'label.COPY',
    id: 'clone_departments',
    label: 'label.GROUPS',
    value: 'clone_departments'
  },
  clone_images: {
    group: 'label.COPY',
    id: 'clone_images',
    label: 'label.IMAGES',
    value: 'clone_images'
  },
  clone_tagblocks: {
    group: 'label.COPY',
    id: 'clone_tagblocks',
    label: 'label.SIGNATURES',
    value: 'clone_tagblocks'
  },
  clone_department_assignment: {
    group: 'label.COPY',
    id: 'clone_department_assignment',
    label: 'label.SIGNATURE_ROUTES',
    value: 'clone_department_assignment'
  },
  clone_bizcards: {
    group: 'label.COPY',
    id: 'clone_bizcards',
    label: 'label.BUSINESS_CARDS',
    value: 'clone_bizcards'
  },
  clone_bizcard_assignment: {
    group: 'label.COPY',
    id: 'clone_bizcard_assignment',
    label: 'label.BUSINESS_CARDS_ROUTES',
    value: 'clone_bizcard_assignment'
  },
  clone_employee_branding: {
    group: 'label.COPY',
    id: 'clone_employee_branding',
    label: 'label.EMPLOYEE_BRANDING',
    value: 'clone_employee_branding'
  },
  clone_employee_branding_assignment: {
    group: 'label.COPY',
    id: 'clone_employee_branding_assignment',
    label: 'label.EMPLOYEE_BRANDING_ROUTES',
    value: 'clone_employee_branding_assignment'
  },

  replace_all_ads: {
    group: 'label.REPLACE',
    id: 'replace_all_ads',
    label: 'label.ADS',
    value: 'replace_all_ads'
  },
  replace_all_departments: {
    group: 'label.REPLACE',
    id: 'replace_all_departments',
    label: 'label.GROUPS',
    value: 'replace_all_departments'
  },
  replace_all_images: {
    group: 'label.REPLACE',
    id: 'replace_all_images',
    label: 'label.IMAGES',
    value: 'replace_all_images'
  },
  replace_all_tagblocks: {
    group: 'label.REPLACE',
    id: 'replace_all_tagblocks',
    label: 'label.SIGNATURES',
    value: 'replace_all_tagblocks'
  },
  replace_all_department_assignments: {
    group: 'label.REPLACE',
    id: 'replace_all_department_assignments',
    label: 'label.SIGNATURE_ROUTES',
    value: 'replace_all_department_assignments'
  },
  replace_all_bizcards: {
    group: 'label.REPLACE',
    id: 'replace_all_bizcards',
    label: 'label.BUSINESS_CARDS',
    value: 'replace_all_bizcards'
  },
  replace_all_bizcard_assignments: {
    group: 'label.REPLACE',
    id: 'replace_all_bizcard_assignments',
    label: 'label.BUSINESS_CARDS_ROUTES',
    value: 'replace_all_bizcard_assignments'
  },
  replace_all_employee_branding: {
    group: 'label.REPLACE',
    id: 'replace_all_employee_branding',
    label: 'label.EMPLOYEE_BRANDING',
    value: 'replace_all_employee_branding'
  },
  replace_all_employee_branding_assignments: {
    group: 'label.REPLACE',
    id: 'replace_all_employee_branding_assignments',
    label: 'label.EMPLOYEE_BRANDING_ROUTES',
    value: 'replace_all_employee_branding_assignments'
  },

  abm_settings: {
    group: 'label.DOMAIN_SETTINGS',
    id: 'abm_settings',
    label: 'label.ABM',
    value: 'abm_settings'
  },
  billing: {
    group: 'label.DOMAIN_SETTINGS',
    id: 'billing',
    label: 'label.BILLING',
    value: 'billing'
  },
  blankoverrideunlocked: {
    group: 'label.DOMAIN_SETTINGS',
    id: 'blankoverrideunlocked',
    label: 'label.BLANK_OVERRIDE_UNLOCKED',
    value: 'blankoverrideunlocked'
  },
  favicon_src: {
    group: 'label.DOMAIN_SETTINGS',
    id: 'favicon_src',
    label: 'label.COMPANY_FAVICON',
    value: 'favicon_src'
  },
  logo_src: {
    group: 'label.DOMAIN_SETTINGS',
    id: 'logo_src',
    label: 'label.COMPANY_LOGO',
    value: 'logo_src'
  },
  fieldmappings: {
    group: 'label.DOMAIN_SETTINGS',
    id: 'fieldmappings',
    label: 'label.FIELD_MAPPINGS',
    value: 'fieldmappings'
  },
  folder_settings: {
    group: 'label.DOMAIN_SETTINGS',
    id: 'folder_settings',
    label: 'label.FOLDERS',
    value: 'folder_settings'
  },
  login_settings: {
    group: 'label.DOMAIN_SETTINGS',
    id: 'login_settings',
    label: 'label.LOGIN_SETTINGS',
    value: 'login_settings'
  },
  outlookaddin_settings: {
    group: 'label.DOMAIN_SETTINGS',
    id: 'outlookaddin_settings',
    label: 'label.ADDIN_SETTINGS',
    value: 'outlookaddin_settings'
  },
  marketing_settings: {
    group: 'label.DOMAIN_SETTINGS',
    id: 'marketing_settings',
    label: 'label.MARKETING',
    value: 'marketing_settings'
  },
  vcard_settings: {
    group: 'label.DOMAIN_SETTINGS',
    id: 'vcard_settings',
    label: 'VCards',
    value: 'vcard_settings'
  },
  sfdc_settings: {
    group: 'label.INTEGRATIONS',
    id: 'sfdc_settings',
    label: 'Salesforce',
    value: 'sfdc_settings'
  },
  airtable_settings: {
    group: 'label.DIRECTORY',
    id: 'airtable_settings',
    label: 'Airtable',
    value: 'airtable_settings'
  },
  bamboohr_settings: {
    group: 'label.DIRECTORY',
    id: 'bamboohr_settings',
    label: 'BambooHR',
    value: 'bamboohr_settings'
  },
  customdir_settings: {
    group: 'label.DIRECTORY',
    id: 'customdir_settings',
    label: 'label.CUSTOM_DIRECTORY',
    value: 'customdir_settings'
  },
  gsuite_settings: {
    group: 'label.DIRECTORY',
    id: 'gsuite_settings',
    label: 'label.GOOGLE_WORKSPACE',
    value: 'gsuite_settings'
  },
  mangoapps_settings: {
    group: 'label.DIRECTORY',
    id: 'mangoapps_settings',
    label: 'label.MANGOAPPS',
    value: 'mangoapps_settings'
  },
  o365_settings: {
    group: 'label.DIRECTORY',
    id: 'o365_settings',
    label: 'Microsoft 365',
    value: 'o365_settings'
  },
  okta_settings: {
    group: 'label.DIRECTORY',
    id: 'okta_settings',
    label: 'Okta',
    value: 'okta_settings'
  },
  sftp_settings: {
    group: 'label.DIRECTORY',
    id: 'sftp_settings',
    label: 'SFTP',
    value: 'sftp_settings'
  },
  workday_settings: {
    group: 'label.DIRECTORY',
    id: 'workday_settings',
    label: 'Workday',
    value: 'workday_settings'
  }
};
